import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch (e) {
        const denied = e?.response?.status === 403;
        window.history.replaceState(null, "", "/admin/login");
        navigate("/admin/login", { replace: true, state: { denied } });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <main className="min-h-screen bg-steel flex items-center justify-center" data-testid="auth-callback">
      <Loader2 size={24} className="text-goldsoft animate-spin" />
    </main>
  );
}
